/**
 * Chakra UI v3 Compatibility Hook
 * Provides useColorModeValue functionality for v2 → v3 migration
 * 
 * In v3, colors are applied via props like: bg="white" _dark={{ bg: 'gray.800' }}
 * This hook returns the light mode value (v3 handles dark mode via CSS)
 */

export function useColorModeValue(lightValue: string, _darkValue: string): string {
  // For now, just return the light value
  // Chakra v3 applies dark mode via _dark prop automatically
  // TODO: Implement proper color mode detection if needed
  return lightValue;
}
